import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import './style.scss';

const Button = ({ className, to, href, small, mini, primary, secondary, success, warning, link, disabled, children, ...props }) => {
	const classes = ['button'];

	if (primary) {
		classes.push('primary');
	}
	if (secondary) {
		classes.push('secondary');
	}
	if (success) {
		classes.push('success');
	}
	if (warning) {
		classes.push('warning');
	}
	if (link) {
		classes.push('link');
	}
	if (small) {
		classes.push('small');
	}
	if (mini) {
		classes.push('mini');
	}
	if (disabled) {
		classes.push('disabled');
	}
	if (className) {
		classes.push(className);
	}

	if (to) {
		return (
			<Link to={to} className={classes.join(' ')} {...props}>
				{children}
			</Link>
		);
	}

	return (
		<a href={href} className={classes.join(' ')} {...props}>
			{children}
		</a>
	);
};

Button.propTypes = {
	children: PropTypes.node,
	className: PropTypes.string,
	to: PropTypes.string,
	href: PropTypes.string,
	primary: PropTypes.bool,
	secondary: PropTypes.bool,
	warning: PropTypes.bool,
	success: PropTypes.bool,
	small: PropTypes.bool,
	mini: PropTypes.bool,
	link: PropTypes.bool,
	disabled: PropTypes.bool
};

export default Button;
